import * as stylex from '@stylexjs/stylex';
import Link from 'next/link';
import { a11y } from '../styles/a11y';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { border, color, shadow, spacing } from '../styles/tokens.stylex';
import { CompanyLogo } from './Logo';
import { calloutTypographyColors } from '../styles/themes';
interface HeaderProps {
  navigation?: React.ReactNode;
  color?: keyof typeof headerColorVariants;
  elevation?: boolean;
  hideHeader?: boolean;
  styles?: stylex.StyleXStyles;
}
export function Header({
  navigation,
  color = 'light',
  elevation = true,
  hideHeader = false,
  styles
}: HeaderProps) {
  if (hideHeader) {
    return <div />;
  }
  return <header {...stylex.props(layout.sectionWrapper, sx.header, headerColorVariants[color], elevation && sx.headerElevation, styles)}>
      <div {...stylex.props(color === 'dark' && calloutTypographyColors, layout.maxWidthWrapper, sx.headerContentWrapper)}>
        <Link {...stylex.props(a11y.focusRing, sx.anchor)} href="/" aria-label="A&O Home Page">
          <CompanyLogo size="reg" color={color === 'dark' ? 'white' : 'primary'} />
        </Link>
        <div className="x16qia4s x12h1iku x78zum5 x1t1x2f9 x1iyjqo2 xs83m0k x13a6bvl">{navigation}</div>
      </div>
    </header>;
}
export const sx = {
  header: {
    k8WAf4: "xt0xc96",
    $$css: true
  },
  headerElevation: {
    kGVxlE: "x1xt9a6s",
    kL6WhQ: "x110ddbf",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    $$css: true
  },
  headerContentWrapper: {
    kOIVth: "x1mhrlx8",
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    $$css: true
  },
  navContainer: {
    kanfag: "x16qia4s",
    k9g6sI: "x12h1iku",
    k1xSpc: "x78zum5",
    kCS8Yb: "x1t1x2f9",
    kzQI83: "x1iyjqo2",
    kmuXW: "xs83m0k",
    kjj79g: "x13a6bvl",
    $$css: true
  },
  anchor: {
    k1xSpc: "x1lliihq",
    kLWn49: "xo5v014",
    $$css: true
  }
};
const headerColorVariants = {
  dark: {
    kWkggS: "x97tsy9",
    $$css: true
  },
  light: {
    kWkggS: "x7d3uan",
    $$css: true
  }
};